// extracted by mini-css-extract-plugin
export var container = "KeyConceptWidget-module--container--28b89";
export var icon = "KeyConceptWidget-module--icon--5cec6";
export var keyConceptCell = "KeyConceptWidget-module--keyConceptCell--b53f0";
export var keyConceptsContainer = "KeyConceptWidget-module--keyConceptsContainer--698d2";